var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangelog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcca19",
    d: "M461.867 408.253C494.411 364.444 512 311.574 512 256c0-68.38-26.628-132.667-74.98-181.02C388.667 26.629 324.38 0 256 0v30c60.367 0 117.121 23.508 159.806 66.194C458.492 138.88 482 195.633 482 256c0 48.763-15.347 95.163-43.742 133.7l-3.439-39.309-29.886 2.614 7.844 89.657 89.658-7.844-2.614-29.886z",
    opacity: 1,
    "data-original": "#24b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2ee6a8",
    d: "M30 256c0-48.763 15.347-95.163 43.742-133.7l3.439 39.309 29.886-2.614-7.844-89.657-89.658 7.843 2.614 29.886 37.953-3.32C17.589 147.556 0 200.426 0 256c0 68.38 26.628 132.667 74.98 181.02C123.333 485.371 187.62 512 256 512v-30c-60.367 0-117.121-23.508-159.806-66.194C53.508 373.12 30 316.367 30 256z",
    opacity: 1,
    "data-original": "#2ee6a8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283366",
    d: "M377 256c0-7.806-.752-15.439-2.171-22.838l29.416-9.558-9.271-28.531-29.434 9.564a121.622 121.622 0 0 0-26.869-36.904l18.22-25.078-24.271-17.634-18.198 25.048A120.081 120.081 0 0 0 271 135.929V105h-15l-20 151 20 151h15v-30.929a120.1 120.1 0 0 0 43.422-14.14l18.198 25.048 24.271-17.634-18.22-25.078a121.593 121.593 0 0 0 26.869-36.904l29.434 9.564 9.271-28.531-29.416-9.558A121.153 121.153 0 0 0 377 256z",
    opacity: 1,
    "data-original": "#283366",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404a80",
    d: "M241 105v30.929a120.1 120.1 0 0 0-43.422 14.14l-18.198-25.048-24.271 17.634 18.22 25.078a121.593 121.593 0 0 0-26.869 36.904l-29.434-9.564-9.271 28.531 29.416 9.558a121.153 121.153 0 0 0 0 45.676l-29.416 9.558 9.271 28.531 29.434-9.564a121.622 121.622 0 0 0 26.869 36.904l-18.22 25.078 24.271 17.634 18.198-25.048A120.081 120.081 0 0 0 241 376.071V407h15V105z",
    opacity: 1,
    "data-original": "#404a80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101040",
    d: "m256 165-20 91 20 91c50.178 0 91-40.822 91-91s-40.822-91-91-91z",
    opacity: 1,
    "data-original": "#101040",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283366",
    d: "M165 256c0 50.178 40.822 91 91 91V165c-50.178 0-91 40.822-91 91z",
    opacity: 1,
    "data-original": "#283366",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfe6",
    d: "m256 210-20 46 20 46c25.405 0 46-20.595 46-46s-20.595-46-46-46z",
    opacity: 1,
    "data-original": "#cfcfe6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ece6f2",
    d: "M210 256c0 25.405 20.595 46 46 46v-92c-25.405 0-46 20.595-46 46z",
    opacity: 1,
    "data-original": "#ece6f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangelog);
export default __webpack_public_path__ + "static/media/changelog.ffacec531e9a949f92a51c8fa2a512d8.svg";
export { ForwardRef as ReactComponent };